import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Avatar,
  Box,
  Button,
  Dropdown,
  DropdownBody,
  DropdownItem,
  getColor,
  Icons,
  InfiniteScrollBox,
  Tabs,
  Tooltip,
  Typography,
  useToast,
} from "fds";
import "../index.scss";
import dayjs from "dayjs";
import utilsCommon from "../../../shared/utils/common";
import { DocInfo, DocumentListReq } from "../../../types/files";
import useWorkgroupStore from "../../../redux/dispatcher/useWorkgroupStore";
import { meetingDTO, MeetingRequest } from "../../../types/meeting";
import MeetingBottom from "../../../components/MeetingBottom";
import DateDropdown from "../../../components/DateDropdown";
import classNames from "classnames";
import RevisionTag from "../../../components/RevisionTag";
import utilsDocs from "../../../shared/utils/docs";
import { Workgroup } from "../../../types/workgroup";
import useDocumentStore from "../../../redux/dispatcher/useDocumentStore";
import EmptyInitFilterPage from "../../../components/EmptyPage/EmptyInitFilterPage";
import EmptyFilterPage from "../../../components/EmptyPage/EmptyFilterPage";
import { nanoid } from "@reduxjs/toolkit";
import useMeetingStore from "../../../redux/dispatcher/useMeetingStore";
import {
  doUnauthDocDownload,
  handleDocDownload,
  handleDocPreview,
} from "../../../shared/utils/api";
import useStartDownload from "../../../shared/hooks/useStartDownload";
import { Trans, useTranslation } from "react-i18next";
import { t } from "i18next";
import WorkgroupAvatar from "../../../components/WorkgroupAvatar";
import { getUserInfoFromLocalStorage } from "../../../shared/utils/auth";
import { LoginDto } from "../../../types/auth";
const sort_by = [
  { resource: t("common.sortDateNewFirst"), key: "datedesc" },
  { resource: t("common.sortDateNewLast"), key: "date" },
  { resource: t("common.sortDateNameAsc"), key: "name" },
  { resource: t("common.sortDateNameDesc"), key: "namedesc" },
];
const user = getUserInfoFromLocalStorage() as string | "";
const loginDto: LoginDto = JSON.parse(user);
const TAB_VALUES = [
  { key: "file", resource: t("common.file"), index: 0 },
  {
    key: "meeting",
    resource: t("common.meetings"),
    index: 1,
    isHidden:
      utilsCommon.checkMenuAvailable("zoom") === false ||
      loginDto?.ecoSystemLicenseStats?.featureAccessType === "LITE",
  },
];
const ClientSearch = () => {
  const urlParmas = new URLSearchParams(window.location.search);
  const direction = document.documentElement.dir; // 'ltr' 또는 'rtl'

  const INIT_MEETING_FILTER = {
    date: {
      start: utilsCommon.getStartPeriod("1month"),
      end: dayjs().valueOf(),
    },
    order: "datedesc",
    pageNo: 0,
    resultSize: 20,
    searchFor: "filterSearch",
    searchUser: "",
    searchKeyword: "",
    startTime: "",
    timeDirection: "",
    ver: "1.0",
    workgroupIds: [],
  };

  const INIT_CONTENT_FILTER = {
    date: {
      start: utilsCommon.getStartPeriod("1month"),
      end: dayjs().valueOf(),
    },
    folderCode: "",
    masterUserId: "",
    order: "datedesc",
    page: 0,
    readType: "",
    search: "",
    size: 50,
    tagCodes: [],
  };

  const documentListNewCard = useRef([] as any[]);
  const {
    documentState,
    getContentList,
    getContentFavorite,
    getContentDownload,
    getDocDecryptDownload,
  } = useDocumentStore();
  const startDownload = useStartDownload();
  const { workgroupState } = useWorkgroupStore();
  const { meetingState, getMeetingListBySearchKeyword } = useMeetingStore();
  const [keyword, changeKeyword] = useState("");
  const [settingButtonInfo, setDocSettingInfo] = useState<{
    x: number;
    y: number;
    syncId: string;
    docInfo?: DocInfo;
  }>({
    x: 0,
    y: 0,
    syncId: "",
    docInfo: undefined,
  });
  const { t } = useTranslation();

  const [buttonClick, setButtonClick] = useState(0);
  const [meetingList, changeMeetingList] = useState<meetingDTO[]>([]);
  const [docList, changeDocList] = useState<DocInfo[]>();
  const [dateFilter, changeDateFilter] = useState<string>("1month");
  const [tab, changeTab] = useState(0);
  const [docFilter, changeDocFilters] =
    useState<DocumentListReq>(INIT_CONTENT_FILTER);
  const [meetingFilter, changeMeetingFilters] =
    useState<MeetingRequest>(INIT_MEETING_FILTER);
  const [key, setKey] = useState(0);
  const inputRef = useRef<HTMLTableRowElement>(null);

  const toasts = useToast();
  useEffect(() => {
    const givenKeyWord = urlParmas.get("keyworkd") ?? urlParmas.get("keyword");
    changeKeyword(givenKeyWord ? decodeURI(givenKeyWord) : "");
  }, [urlParmas]);
  const handleClickOutside = useCallback((e?: MouseEvent) => {
    if (inputRef.current && !(inputRef.current! as any).contains(e?.target)) {
      handleTurnOffSettng();
      document.removeEventListener("click", handleClickOutside, true);
    }
  }, []);
  useEffect(() => {
    if (!keyword) return;
    changeDocFilters({
      ...docFilter,
      search: keyword ? decodeURI(keyword) : "",
      tagCodes: workgroupState.simpleWorkgroupList.map(
        (item: Workgroup) => item.workgroupId
      ),
    });
    changeMeetingFilters({
      ...meetingFilter,
      searchKeyword: keyword ? decodeURI(keyword) : "",
      workgroupIds: workgroupState.simpleWorkgroupList.map(
        (item: Workgroup) => item.workgroupId
      ),
    });
  }, [keyword]);
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    document.addEventListener("scroll", handleTurnOffSettng, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
      document.removeEventListener("scroll", handleTurnOffSettng, true);
    };
  });
  useEffect(() => {
    let newDataCardContent = [] as any[];
    docList?.forEach((item: DocInfo, index: number) =>
      newDataCardContent.push(getTableCardData(item, index))
    );
    documentListNewCard.current = newDataCardContent;
    setKey(key + 1);
  }, [docList]);

  useEffect(() => {
    changeDocList(documentState.docList);
  }, [documentState.docList]);
  useEffect(() => {
    changeMeetingList(meetingState.meetingList);
  }, [meetingState.meetingList]);
  useEffect(() => {
    if (docFilter.search) getContentList(docFilter);
  }, [docFilter]);
  useEffect(() => {
    if (
      meetingFilter.searchKeyword &&
      loginDto?.ecoSystemLicenseStats?.featureAccessType !== "LITE"
    )
      getMeetingListBySearchKeyword(meetingFilter);
  }, [meetingFilter]);
  const handleTurnOffSettng = (): void => {
    setDocSettingInfo({
      x: 0,
      y: 0,
      syncId: "",
      docInfo: undefined,
    });
  };
  /** 문서 상세정보 모달 열기 기능 */
  const handleOpenClientDocInfo = (syncId: string) => {
    if (utilsCommon.isClientLogin("MAC")) {
      (window as any)?.webkit?.messageHandlers.DocDetail.postMessage(syncId);
    } else if (utilsCommon.isClientLogin("WINDOWS")) {
      window?.chrome?.webview?.hostObjects.client.DocDetail(syncId);
    }
    handleTurnOffSettng();
  };
  /** 문서 다운로드 기능 */
  const handleDocClientDownload = async (syncId: string) => {
    handleDocDownload(
      syncId,
      getContentDownload,
      toasts,
      t,
      "0",
      docList?.filter((item) => item.syncId === syncId)[0]?.contentName ?? ""
    );

    handleTurnOffSettng();
  };

  const getTableCardData = (row: DocInfo, index: any) => {
    return {
      id: row?.syncId,
      data: (
        <Box classes="clientFile-item">
          <Box classes="clientEco-groups">
            <WorkgroupAvatar item={row.workgroup} />
            {utilsDocs.renderDocIcon(row?.contentName, 32)}
          </Box>
          <Box direction="column" width={"calc(100% - 85px)"} classes="mg ml-8">
            <Box alignItems="center">
              <Tooltip
                message={row?.contentName}
                maxWidth={"calc(100% - 25px)"}
              >
                <Typography
                  type="body2_rg"
                  ellipsis
                  onClick={() =>
                    handleDocPreview({
                      permission: "view",
                      workgroupId: row.workgroup.workgroupId,
                      syncId: row.syncId,
                      toast: toasts,
                      t,
                      revisionNo: 0,
                    })
                  }
                  classes={classNames({
                    "hover-text-underline": utilsCommon.checkMenuAvailble(
                      "preview",
                      row
                    ),
                  })}
                >
                  {row?.contentName}
                </Typography>
              </Tooltip>
              {row?.revisionNo > 1 && (
                <RevisionTag
                  classes={"mg ml-4"}
                  size={"sm"}
                  revisionNo={row?.revisionNo}
                />
              )}
            </Box>
            <Box classes="mg mt-6">
              <Tooltip
                message={row?.masterUser?.userName}
                maxWidth={"calc(100% - 125px)"}
              >
                <Typography
                  type="caption1_rg"
                  ellipsis
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {row?.masterUser?.userName}
                </Typography>
              </Tooltip>
              <Typography
                type="caption1_rg"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
                classes="mg ml-4"
              >
                {` · ${utilsCommon.renderDateFormat(row?.revisionDate)}`}
              </Typography>
            </Box>
          </Box>
          {row?.authType !== "N" &&
            !!row?.favoritDate &&
            row?.favoritDate > 0 && (
              <Box
                classes="cursor pointer mg ml-auto"
                width={32}
                justifyContent="center"
              >
                <Icons variant="fill" label="star" isColored size={20} />
              </Box>
            )}
          {row?.authType !== "N" && (
            <Box classes="hover-actions">
              <Button
                btnStyle={"icon"}
                size="sm"
                onClick={(e) => {
                  e.stopPropagation();
                  setDocSettingInfo({
                    x: direction ? e.pageX : e.pageX - 120,
                    y:
                      350 > e.pageY
                        ? e.pageY
                        : e.pageY -
                          (utilsCommon.checkMenuAvailble(
                            "unAuthDownload",
                            settingButtonInfo.docInfo,
                            "client"
                          )
                            ? 52
                            : 98),
                    syncId: row?.syncId,
                    docInfo: row,
                  });
                }}
                leadingIcon={<Icons variant="line" label="moreVertical" />}
              />
              <Tooltip
                message={
                  row?.favoritDate > 0
                    ? t("file.action.removeFav")
                    : t("file.action.addFav")
                }
              >
                <Button
                  btnStyle="icon"
                  onClick={() =>
                    getContentFavorite({
                      syncIds: [row?.syncId],
                      flag: row?.favoritDate <= 0,
                    })
                  }
                  leadingIcon={
                    <Icons
                      variant="fill"
                      label="star"
                      isColored={!!row?.favoritDate && row?.favoritDate > 0}
                      size={20}
                    />
                  }
                />
              </Tooltip>
            </Box>
          )}
        </Box>
      ),
    };
  };
  const changeFilterByKey = (key: string, value: any) => {
    let newValue = value;
    if (key === "order") {
      if (value.includes("_direct")) {
        newValue = value.split("_direct")[0];
      } else {
        if (value === "name") {
          if (meetingFilter.order.includes("date")) {
            newValue = "namedesc";
          } else {
            newValue = meetingFilter.order === "namedesc" ? "name" : "namedesc";
          }
        } else {
          if (meetingFilter.order.includes("name")) {
            newValue = "datedesc";
          } else {
            newValue = meetingFilter.order === "datedesc" ? "date" : "datedesc";
          }
        }
      }
    } else if (key === "date") {
      if (typeof value !== "object") {
        document.getElementById("inifinteScroll")?.scrollTo(0, 0);
        changeDateFilter(value);
        changeMeetingFilters({
          ...meetingFilter,
          pageNo: 0,
          date: {
            start: utilsCommon.getStartPeriod(value),
            end: dayjs().valueOf(),
          },
        });
        changeDocFilters({
          ...docFilter,
          page: 0,
          date: {
            start: utilsCommon.getStartPeriod(value),
            end: dayjs().valueOf(),
          },
        });
      } else {
        document.getElementById("inifinteScroll")?.scrollTo(0, 0);
        changeDateFilter("custom");
        changeDocFilters({
          ...docFilter,
          page: 0,
          date: {
            start: dayjs(value.start).valueOf(),
            end: dayjs(value.end).valueOf(),
          },
        });
        changeMeetingFilters({
          ...meetingFilter,
          pageNo: 0,
          date: {
            start: dayjs(value.start).valueOf(),
            end: dayjs(value.end).valueOf(),
          },
        });
      }
      return;
    } else if (key === "page") {
      if (docList && docList?.length < documentState.docListInfo?.total)
        changeDocFilters({ ...docFilter, [key]: value });
      return;
    } else if (key === "pageNo") {
      if (meetingList.length < meetingState.meetingListInfo?.total)
        changeMeetingFilters({ ...meetingFilter, [key]: value });
      return;
    }
    document.getElementById("inifinteScroll")?.scrollTo(0, 0);
    changeMeetingFilters({ ...meetingFilter, pageNo: 0, [key]: newValue });
    changeDocFilters({
      ...docFilter,
      page: 0,
      [key]: newValue.replace("name", "file"),
    });
  };
  const renderFileFilter = () => {
    return (
      <Box classes="clientFile-filter">
        <DateDropdown
          filter={meetingFilter}
          buttonClick={buttonClick}
          showValue={false}
          positionStrategy="fixed"
          setButtonClick={setButtonClick}
          dateFilter={dateFilter}
          changeFilterByKey={changeFilterByKey}
          isClient
          initValue="1month"
        />
      </Box>
    );
  };
  return (
    <Box
      classes="clientBookmark clientWorkgroupBody"
      width={"calc(100% - 64px)"}
    >
      <Box height={88} alignItems="center" classes="clientBookmark-header ">
        <Typography type="h2" style={{ display: "inline-flex" }}>
          <Trans
            i18nKey="search.title"
            values={{ keyword: keyword }}
            components={{
              1: (
                <Typography
                  type="h2"
                  ellipsis
                  maxWidth={200}
                  style={{ display: "inline-block" }}
                  classes="mg ml-4 mr-4"
                  exactColor={getColor("COLOR_TEXT_BRAND")}
                />
              ),
            }}
          />
        </Typography>
      </Box>
      <Tabs
        type={"leftFull"}
        selected={tab}
        textAlign={"left"}
        selectTab={(newTab) => changeTab(newTab)}
        tabs={TAB_VALUES.map((item) => {
          return {
            text: item.resource,
            color: "default",
            isNew: false,
            isHidden: item.isHidden,
          };
        })}
        paddingLeft={20}
        size={"lg"}
      />
      <Box classes="clientWorkgroupBody-header">
        <Dropdown
          btnStyle="link"
          placeholder="asdf"
          buttonClick={buttonClick}
          value={
            sort_by.filter((item) => item.key === meetingFilter.order)[0]
              .resource
          }
        >
          {sort_by.map((item) => (
            <DropdownItem
              label={item.resource}
              type="check"
              checked={item.key === meetingFilter.order}
              checkColor={item.key === meetingFilter.order}
              onClick={() => {
                changeFilterByKey("order", item.key + "_direct");
                setButtonClick(buttonClick + 1);
              }}
            />
          ))}
        </Dropdown>
      </Box>
      {renderFileFilter()}
      {tab === 0 ? (
        documentState.docListInfo?.docs?.doc?.length === 0 ? (
          dateFilter === "1month" ? (
            <EmptyInitFilterPage pageType={"client"} />
          ) : (
            <EmptyFilterPage
              pageType={"client"}
              handleInitFilter={() => {
                changeDocFilters({
                  ...docFilter,
                  search: keyword ? decodeURI(keyword) : "",
                  tagCodes: workgroupState.simpleWorkgroupList.map(
                    (item: Workgroup) => item.workgroupId
                  ),
                });
                changeDateFilter("1month");
              }}
            />
          )
        ) : (
          <InfiniteScrollBox
            data={documentListNewCard.current}
            height={"388px"}
            width="100%"
            endReached={() =>
              docList &&
              docList?.length < documentState.docListInfo.total &&
              changeDocFilters({ ...docFilter, page: docFilter.page + 1 })
            }
          />
        )
      ) : (
        <MeetingBottom
          meetingList={meetingList}
          isInitFilter={dateFilter === "1month"}
          filter={meetingFilter}
          tableHeight="380px"
          changeFilterByKey={changeFilterByKey}
          handleInitFilter={() => {
            changeDocFilters({
              ...docFilter,
              search: keyword ? decodeURI(keyword) : "",
              tagCodes: workgroupState.simpleWorkgroupList.map(
                (item: Workgroup) => item.workgroupId
              ),
            });
            changeMeetingFilters({
              ...INIT_MEETING_FILTER,
              date: {
                start: utilsCommon.getStartPeriod("1month"),
                end: dayjs().valueOf(),
              },
              searchKeyword: keyword ? decodeURI(keyword) : "",
              workgroupIds: workgroupState.simpleWorkgroupList.map(
                (item: Workgroup) => item.workgroupId
              ),
            });
            changeDateFilter("1month");
          }}
          page="client_search"
        />
      )}
      {settingButtonInfo.syncId && (
        <DropdownBody
          align="right"
          width={"120px"}
          dropdownRef={inputRef}
          location={{ x: settingButtonInfo.x, y: settingButtonInfo.y }}
        >
          {utilsCommon.checkMenuAvailble(
            "unAuthDownload",
            settingButtonInfo.docInfo,
            "client"
          ) ? (
            <DropdownItem
              label={t("file.action.download")}
              frontIcon={<Icons variant="line" label="download" />}
              onClick={() =>
                settingButtonInfo.docInfo &&
                doUnauthDocDownload(
                  settingButtonInfo.docInfo,
                  toasts,
                  getDocDecryptDownload,
                  startDownload
                )
              }
            />
          ) : (
            <>
              <DropdownItem
                label={t("file.action.download")}
                frontIcon={<Icons variant="line" label="download" />}
                onClick={() =>
                  handleDocClientDownload(settingButtonInfo.syncId)
                }
              />
              <DropdownItem
                label={t("file.detail")}
                frontIcon={<Icons variant="line" label="info" />}
                onClick={() =>
                  handleOpenClientDocInfo(settingButtonInfo.syncId)
                }
              />
            </>
          )}
        </DropdownBody>
      )}
    </Box>
  );
};

export default ClientSearch;
